export enum VirtualServiceArea {
  CODE = 'tmp',
  NAME = 'Virtual',
}
